export function getHiprojectsModalState(state) {
  return !!state.modals.status.hiprojects;
}

export function getCloseJobModalState(state) {
  return state.modals.status.closejob;
}

export function getJobDetailsModalState(state) {
  return state.modals.status.jobdetails;
}

export function getFeedbackMessageModalStatus(state) {
  return state.modals.status.feedbackMessage;
}

/**
 * Data selectors (for data that needs to be passed into a modal)
 */
export function getFeedbackMessageModalData(state) {
  return state.modals.list.feedbackMessage;
}
